(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  const desktopQuery = "(min-width: 1400px)";

  if (window.matchMedia(desktopQuery).matches) {
    ////////////////////////////////////////////////////////////////////////////////////
    // Dropdown hover
    ////////////////////////////////////////////////////////////////////////////////////
    $('.navbar-nav li.dropdown').hover(function() {
      $(this).find('.js-dropdown-menu').stop(true, true).delay(200).fadeIn(200);
      $(this).find('.js-dropdown-toggle').addClass('show');

      setTimeout(function() {
        $('body').addClass('navbar-dropdown-active');
      }, 400);

    }, function() {
      $(this).find('.js-dropdown-menu').stop(true, true).delay(200).fadeOut(200);
      $(this).find('.js-dropdown-toggle').removeClass('show');
      
      setTimeout(function() {
        $('body').removeClass('navbar-dropdown-active');
      }, 400);

    }); 
  } else {
    $('.navbar-nav li.dropdown').off('hover');
  }

  $(window).on('resize', function () {
    if (window.matchMedia(desktopQuery).matches) {
      ////////////////////////////////////////////////////////////////////////////////////
      // Dropdown hover
      ////////////////////////////////////////////////////////////////////////////////////
      $('.navbar-nav li.dropdown').hover(function() {
        $(this).find('.js-dropdown-menu').stop(true, true).delay(200).fadeIn(200);
        $(this).find('.js-dropdown-toggle').addClass('show');
        
        setTimeout(function() {
          $('body').addClass('navbar-dropdown-active');
        }, 400);

      }, function() {
        $(this).find('.js-dropdown-menu').stop(true, true).delay(200).fadeOut(200);
        $(this).find('.js-dropdown-toggle').removeClass('show');

        setTimeout(function() {
          $('body').removeClass('navbar-dropdown-active');
        }, 400);

      }); 
    } else {
      $('.navbar-nav li.dropdown').off('hover mouseenter mouseleave');
    }
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // Sticky Scroll Nav
        ////////////////////////////////////////////////////////////////////////////////////
        sticky_scroll_header();

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            
            $(this).find('.text-search').addClass('d-none');
            $(this).find('.text-close').removeClass('d-none').addClass('d-flex');

            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');

            $(this).find('.text-search').removeClass('d-none');
            $(this).find('.text-close').addClass('d-none').removeClass('d-flex');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Navbar - Dropdown Toggled
        ////////////////////////////////////////////////////////////////////////////////////
        // Add class when the dropdown is opened
        $(document).on('show.bs.dropdown', '.js-menu-dropdown', function () {
          $('body').addClass('navbar-dropdown-active');
        });

        // Remove class when the dropdown is closed
        $(document).on('hidden.bs.dropdown', '.js-menu-dropdown', function () {
          $('body').removeClass('navbar-dropdown-active');
        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Generic Accordion
        ////////////////////////////////////////////////////////////////////////////////////
        $('.js-accordion-item').on('show.bs.collapse hide.bs.collapse', function() {
          $(this).toggleClass('show');
        });

        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').not('form.variations_form select').each(function() {
          $(this).chosen();
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Ticker Tape - Careers Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_ticker_tape('.js-ticker-tape');
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Stockist Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_category_toggle_block(
          '.js-stockist-category',            // Button / Category Class
          '.js-stockist-dropdown',            // Bootstrap Dropdown Class
          '.js-stockist-categories-content'   // Accordion Wrapper Class
        );

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: FAQ Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_category_toggle_block(
          '.js-faq-category',                 // Button / Category Class
          '.js-faq-dropdown',                 // Bootstrap Dropdown Class
          '.js-faq-categories-content'        // Accordion Wrapper Class
        );

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Products
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_products_block();

        ////////////////////////////////////////////////////////////////////////////////////
        // Journal Filter
        ////////////////////////////////////////////////////////////////////////////////////
        scrollToSectionIfJournalCategory();

        ////////////////////////////////////////////////////////////////////////////////////
        // WooCommerce - Quantity Buttons
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery(document).ready(function ($) {
          $('.js-quantity-wrapper').on('click', '.js-plus, .js-minus', function () {
            // Find the quantity input field within the same wrapper
            var $qty = $(this).closest('.js-quantity-wrapper').find('.qty');
            var currentVal = parseFloat($qty.val());
            var max = parseFloat($qty.attr('max'));
            var min = parseFloat($qty.attr('min')) || 0; // Default min to 0 if not set
            var step = parseFloat($qty.attr('step')) || 1; // Default step to 1 if not set
        
            if ($(this).hasClass('js-plus')) {
              // Increment the quantity
              if (!max || currentVal < max) {
                $qty.val((currentVal + step).toFixed(step % 1 === 0 ? 0 : 1));
              }
            } else if ($(this).hasClass('js-minus')) {
              // Decrement the quantity
              if (currentVal > min) {
                var newVal = currentVal - step;
                $qty.val((newVal < min ? min : newVal).toFixed(step % 1 === 0 ? 0 : 1));
              }
            }
        
            // Trigger change event to ensure WooCommerce updates totals
            $qty.trigger('change');
          });
        }, (jQuery));

        jQuery(document).ready(function ($) {
          $('.js-product-item').on('click', function () {
            var product_contents_wrapper = $(this).closest('.section-flexi-feature-product-content').find('.js-product-contents');
            var tab_content_id = $(this).data('id');
            $('.js-product-item').removeClass('active');
            product_contents_wrapper.find('.js-product-content').removeClass('d-flex').addClass('d-none');
          
            $(this).addClass('active');
            product_contents_wrapper.find('.js-product-content#' + tab_content_id).addClass('d-flex').removeClass('d-none');
          }); 
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // WooCommerce
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery(document).ready(function ($) {
          
          ////////////////////////////////////////////////////////////////////////////////////
          // WooCommerce - Product Page
          ////////////////////////////////////////////////////////////////////////////////////
          $(document).on('click', '.js-product-variant', function (e) {
            e.preventDefault();

            var $this = $(this);
            var attributeName = $this.data('attribute'); // Get the attribute name
            var value = $this.data('value'); // Get the value of the variant
        
            var dropdown = $(this).parent().parent().find('select[name="'+ attributeName + '"]');

            // Remove 'active' class from all buttons within the wrapper
            $(this).siblings().removeClass('active');

            // dropdown.addClass('selected');
            dropdown.val(value).trigger('change');
          });

        });
        
        $(document).on('click', '.reset_variations', function () {
          $('body').find('.variants .js-product-variant').removeClass('active');
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Product Content
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-flexi-variant', function () {
          $this = $(this);
          $product_variant_id = $this.data('variant-id');
          $wrapper = $this.closest('.js-product-variants');

          $wrapper.find('.js-flexi-variant').removeClass('active');

          $this.addClass('active');

          $wrapper.attr('data-variant-id', $product_variant_id);

          $wrapper.parent().find('.js-product-retailers').find('.js-product-retailer').removeClass('d-flex').addClass('d-none');
          $wrapper.parent().find('.js-product-retailers').find('.js-product-retailer#' + $product_variant_id).addClass('d-flex').removeClass('d-none');
        });

        ////////////////////////////////////////////////////////////////////////////////////
        //  Page Header Split Layout
        ////////////////////////////////////////////////////////////////////////////////////
        // Define a function to calculate and apply the offset and width
        function updateFlickityDots() {
          var section_page_header_split = $(document).find('.section-page-header-split-layout .flickity .carousel-cell-copy');
          var section_page_header_split_flickity_dots = $(document).find('.section-page-header-split-layout .flickity .flickity-page-dots');

          if (section_page_header_split.length && section_page_header_split_flickity_dots.length && $(window).width() >= 1200) {
            // Get the width of the carousel-cell
            // Apply the calculated offset left and width to the flickity dots
            section_page_header_split_flickity_dots.css({
              'left': section_page_header_split.offset().left + 'px',
              'width': section_page_header_split.outerWidth() + 'px',
            });
          } else {
            // If the carousel-cell is not found, remove the styles
            section_page_header_split_flickity_dots.removeAttr('style');
          }
        }

        // Run the function on page load
        updateFlickityDots();

        // Bind the function to the window resize event
        $(window).on('resize', function () {
          updateFlickityDots();
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Page Header - Video
        ////////////////////////////////////////////////////////////////////////////////////
        $(function() {
          var lastIsMobile = $(window).width() <= 1199;

          function reloadVideoIfBreakpointChanged() {
            var isMobile = $(window).width() <= 1199;
            if (isMobile !== lastIsMobile) {
              $('.section-page-header .carousel-cell video').each(function() {
                this.load();
              });
              lastIsMobile = isMobile;
            }
          }

          $(window).on('resize', reloadVideoIfBreakpointChanged);
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Product page
    ////////////////////////////////////////////////////////////////////////////////////
    single_product: {
      init: function () {
        $(document).on('click', '.js-product-variant', function () {
          var $this = $(this);
          var $product_variant_id = $this.attr('id');
          var $wrapper = $this.closest('.js-product-variants');
          var $product_image_wrapper = jQuery('body').find('.js-product-image-wrapper');
          var $product_carousel_image_wrapper = jQuery('body').find('.js-product-image-carousel .js-product-image-wrapper');
        
          // Remove 'active' class from all buttons within the wrapper
          $wrapper.find('.js-product-variant').removeClass('active');
        
          // Add 'active' class to the clicked button
          $this.addClass('active');

          // Set the data-active-variant attribute of the wrapper to the clicked button's ID
          $wrapper.attr('data-active-variant', $product_variant_id);

          // Hide all product images
          $product_image_wrapper.find('.js-product-image').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
          });

          $product_carousel_image_wrapper.find('.js-product-image').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
          });

          // Show the image corresponding to the clicked variant
          $product_image_wrapper.find('.js-product-image#' + $product_variant_id).addClass('d-block').removeClass('d-none');
          $product_carousel_image_wrapper.find('.js-product-image#' + $product_variant_id).addClass('d-block').removeClass('d-none');
        });

        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-variant') {
              $retailers_wrapper = $('body').find('.js-product-retailers');
              $active_retailer_info = $retailers_wrapper.find('.js-product-retailer#' + mutation.target.getAttribute('data-active-variant'));

              $active_retailer_info.addClass('d-flex').removeClass('d-none');
              $active_retailer_info.siblings().addClass('d-none').removeClass('d-flex');
            }
          });
        });
        
        // Observe changes to the `.js-product-variants` div
        $('.js-product-variants').each(function () {
          observer.observe(this, { attributes: true });
        });
      }
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
